import { isBlockOnPage } from "../../src/js/modules/block-present.js";

if (isBlockOnPage("faq-accordion")) {
jQuery(document).ready(function ($) {
  function refreshScrollAfterLayout() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var sc = window.SOJ_SMOOTH_SCROLL;
        if (sc && typeof sc.refreshDimensions === "function") {
          sc.refreshDimensions();
        }
      });
    });
  }

  var $root = $(".faq-accordion");
  if (!$root.length) {
    return;
  }

  // Remove any existing event handlers to prevent duplicates
  $root.find(".questions_and_answers .question").off("click");

  $root.find(".questions_and_answers .question").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling

    var $answer = $(this).next(".answer");

    if ($(this).hasClass("active2")) {
      $(this).removeClass("active2");
      $answer.slideUp(300, refreshScrollAfterLayout);
    } else {
      $(this).addClass("active2");
      $answer.slideDown(300, refreshScrollAfterLayout);
    }
  });

  $root.find(".faq-accordion__read-more").on("click", function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $extra = $btn.prev(".faq-accordion__extra-items");
    if (!$extra.length) {
      return;
    }
    var labelMore = $btn.attr("data-label-more") || "Read more";
    var labelLess = $btn.attr("data-label-less") || "Read less";
    var expanded = $btn.attr("aria-expanded") === "true";

    if (expanded) {
      $extra.attr("hidden", "");
      $extra.find(".question").removeClass("active2");
      $extra.find(".answer").removeAttr("style");
      $btn.attr("aria-expanded", "false").text(labelMore);

      var sectionEl = $btn.closest("section.faq-accordion").get(0);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var sc = window.SOJ_SMOOTH_SCROLL;
          if (sc && typeof sc.refreshDimensions === "function") {
            sc.refreshDimensions();
          }
          if (sectionEl) {
            var reduceMotion = window.matchMedia(
              "(prefers-reduced-motion: reduce)"
            ).matches;
            if (
              sc &&
              typeof sc.scrollTo === "function" &&
              !reduceMotion
            ) {
              sc.scrollTo(sectionEl, { offset: -100, duration: 1.2 });
            } else {
              sectionEl.scrollIntoView({
                behavior: reduceMotion ? "auto" : "smooth",
                block: "start",
              });
            }
          }
        });
      });
    } else {
      $extra.removeAttr("hidden");
      $btn.attr("aria-expanded", "true").text(labelLess);
      refreshScrollAfterLayout();
    }
  });
});
}
